import moment from 'moment';

const collections = {
    drawing: 'drawing',
    coatings: 'coatings',
    coilTypes: 'coilTypes',
    finEdges: 'finEdges',
    finMaterials: 'finMaterials',
    finPatterns: 'finPatterns',
    finSurfaces: 'finSurfaces',
    hairPins: 'hairPins',
    tubeDimentions: 'tubeDimentions',
    tubeInsideShapes: 'tubeInsideShapes',
    tubeTypes: 'tubeTypes',
    tubeMaterials: 'tubeMaterials',
    setting: 'setting',
    transferById: 'transferById'
};

const tubeTypeOptions = [
    { key: 'P', value: 'P', text: 'P=Plain' },
    { key: 'G', value: 'G', text: 'G=Groove' }
];
const finTypeOptions = [
    { key: 'AL', value: 'AL', text: 'Bare Fin' },
    { key: 'PC', value: 'PC', text: 'Pre-Coated' },
    { key: 'CU', value: 'CU', text: 'Copper' }
];
const plateTypeOptions = [
    { key: 'ST', value: 'ST', text: 'Steel' },
    { key: 'SS', value: 'SS', text: 'Stainless' },
    { key: 'SS316', value: 'SS316', text: 'Stainless 316' },
    { key: 'AL', value: 'AL', text: 'Aluminum' }
];
const headerOptions = [
    { key: 'CU', value: 'CU', text: 'Copper' },
    { key: 'ST', value: 'ST', text: 'Steel' }
];
const coatingOptions = [
    { key: 'EP', value: 'EP', text: 'Epoxy' },
    { key: 'DC', value: 'DC', text: 'D-Coat' }
];

const makeSelectOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.code, value: e.code, text: e.fullName ? e.fullName : e.name, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};
const makeSelectOption2 = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];

                for (let index = 0; index < e.length; index++) {
                    const d = e[index];
                    result.push({ key: d.id, value: d.id, text: d.fullname, valuedata: hasValue ? e.value : null });
                }
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectIdOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.name, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectOilTypeOption = (datas, lang) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.id, value: e.id, text: lang ? e.nameEn : e.nameTh });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};
const makeSelectUserOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                let fullname = e.fullName ? e.fullName : e.fullname ? e.fullname : '';
                result.push({ key: e.id, value: e.id, text: fullname.toUpperCase(), valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectUserGroupOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                let fullname = e.name ? e.name : e.name ? e.name : '';
                result.push({ key: e.id, value: e.id, text: fullname, valuedata: hasValue ? e.value : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectPipeTypePatternOption = (datas) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.nameIMS, patternId: e.patternId, typeId: e.typeId });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectIdCheckboxOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];

            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.name, valuedata: hasValue ? e.value : null, isChecked: false });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectWarehouseIdOption = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];
            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e.id, value: e.id, text: e.warehouse, valuedata: hasValue ? e.warehouse : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const makeSelectOnlyName = (datas, hasValue) => {
    try {
        if (Array.isArray(datas)) {
            let result = [];
            for (let index = 0; index < datas.length; index++) {
                const e = datas[index];
                result.push({ key: e, value: e, text: e, valuedata: hasValue ? e : null });
            }
            return result;
        }
        return [];
    } catch (error) {
        console.log(error);
        return [];
    }
};

const locationGoogleMap = (startLat, startLng, endLat, endLng) => {
    return `https://www.google.co.th/maps/dir/${startLat},${startLng}/${endLat},${endLng}`;
};

const eventKeyHandle = {
    enter: 13,
    back: 111,
    del: 110,
    help: 106,
    up: 109, //Up Keycode: 109 Arrow Up: 38
    down: 107, //Down Keycode: 107 Arrow Down: 40
    arrowUp: 38,
    arrowDown: 40

    //numlock: 12,
    //
    //message: 91
    //tab: 9
};

const zeroPadStart = (str, count) => String(str).padStart(count, '0');
const zeroPadEnd = (str, count) => String(str).padEnd(count, '0');

const encodeBase64 = (value) => {
    let buff = new Buffer(value);
    let base64data = buff.toString('base64');
    return base64data;
};

const decodeBase64 = (value, type = 'ascii') => {
    let buff = new Buffer(value, 'base64');
    let base64data = buff.toString(type);
    // let base64data = buff.toString('ascii');
    return base64data;
};

const convertUnitMoney = (type, value) => {
    switch (type) {
        case 'money':
            let valueConvert = 0;
            if (value) {
                valueConvert = parseFloat(value)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }
            return valueConvert;

        default:
            return value;
    }
};

const renderDateTime = (row) => {
    let startDate = moment(row.startDateTime).format(dateTimeFm.dateAxFormat);
    let endDate = moment(row.endDateTime).format(dateTimeFm.dateAxFormat);
    let isSame = moment(startDate).isSame(moment(endDate));
    console.log('isSame', isSame);
    if (isSame) {
        return `${startDate} ${moment(row.startDateTime).format('HH:mm')}-${moment(row.endDateTime).format('HH:mm')} `;
    } else {
        return `${moment(row.startDateTime).format(dateTimeFm.dateTimeAxFormat)} - ${moment(row.endDateTime).format(dateTimeFm.dateTimeAxFormat)} `;
    }
};

const statusTransfer = {
    created: 'CREATED',
    transfered: 'TRANFERED',
    received: 'RECEIVED',
    transferedCompleted: 'Transferred – Completed',
    receiveCompleted: 'Receive – Completed',
    completed: 'COMPLETED'
};

const taskMode = {
    myTask: 'mytask',
    draftTask: 'drafttask',
    assignTask: 'assigntask'
};

const reseveCarMode = {
    map: 'map',
    form: 'form',
    userSelect: 'userSelect'
};

const itemStatus = ['WAITING', 'APPROVE', 'GENCODE', 'DELETE'];
const sellOrderStatus = ['SUBMIT', 'PRE-APPROVE', 'APPROVE', 'CUSROMER-APPROVE'];
const measurement = ['Inches', 'mm.'];
const customerType = ['LOCAL', 'INTERNATIONAL'];
const typeOfRequest = ['NEW', 'REV', 'REP'];
const fullDateTimeFormat = 'DD MMM YYYY HH:mm';
const fullDateTimeTrackerFormat = 'DD/MM/YYYY HH:mm';
const dateTimeFormat = 'DD/MM/YYYY HH:mm';
const defaultImage = '/assets/images/tracker/user.png';
const dateTimeFm = {
    dateWithTime: 'YYYY-MM-DDThh:mm',
    dateWithTimeInput: 'YYYY-MM-DDTHH:mm',
    dateTime: 'YYYY-MM-DD HH:mm',
    dateTimeNoDash: 'YYYYMMDD HH:mm',
    dateLimit: 'YYYY-MM-DD', //20220331,
    dateAPI: 'YYYYMMDD', //20220331,
    dateTimeAxFormat: 'DD-MM-YYYY HH:mm',
    dateAxFormat: 'DD-MM-YYYY',
    timeAxFormat: 'HH:mm A',
    dateTimeFormatNew: ' DD/MM/YYYY  (HH:mm A)',
    dateFormat: 'DD/MM/YYYY'
};
export {
    collections,
    makeSelectOption,
    makeSelectOption2,
    zeroPadStart,
    zeroPadEnd,
    itemStatus,
    makeSelectPipeTypePatternOption,
    makeSelectIdOption,
    encodeBase64,
    decodeBase64,
    sellOrderStatus,
    measurement,
    customerType,
    typeOfRequest,
    makeSelectIdCheckboxOption,
    tubeTypeOptions,
    finTypeOptions,
    plateTypeOptions,
    headerOptions,
    coatingOptions,
    convertUnitMoney,
    statusTransfer,
    makeSelectWarehouseIdOption,
    eventKeyHandle,
    fullDateTimeFormat,
    dateTimeFormat,
    defaultImage,
    fullDateTimeTrackerFormat,
    makeSelectOnlyName,
    makeSelectUserOption,
    makeSelectUserGroupOption,
    taskMode,
    dateTimeFm,
    renderDateTime,
    makeSelectOilTypeOption,
    reseveCarMode,
    locationGoogleMap
};



// WEBPACK FOOTER //
// ./src/app/share/constant.js